import React from 'react';

const PageHeader = ({ title, actions }) => (
  <div className="page-header">
    <div>
      <h1 className="page-title">{title}</h1>
    </div>
    {actions && <div className="page-actions">{actions}</div>}
  </div>
);

export default PageHeader;
